"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccountOrders = exports.AccountOrdersProvider = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useCustomer = require("../commerce-api/custom/hooks/useCustomer");
var _uniq = _interopRequireDefault(require("lodash/uniq"));
const _excluded = ["data"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const AccountOrdersContext = /*#__PURE__*/_react.default.createContext({});
const AccountOrdersProvider = ({
  children
}) => {
  const mounted = (0, _react.useRef)();
  const customer = (0, _useCustomer.useCustomer)();
  const [state, setState] = (0, _react.useState)({
    orderIds: [],
    ordersById: {},
    paging: {
      limit: 10,
      offset: 0,
      total: 0
    },
    currentPage: {
      limit: 10,
      offset: 0,
      total: 0
    },
    isLoading: true
  });
  const mergeState = (0, _react.useCallback)(data => {
    // If we become unmounted during an async call that results in updating state, we
    // skip the update to avoid React errors about setting state in unmounted components.
    if (!mounted.current) {
      return;
    }
    setState(_state => _objectSpread(_objectSpread({}, _state), data));
  }, [mounted]);
  const fetchOrders = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* ({
      offset = 0,
      limit = 10
    }) {
      mergeState({
        isLoading: true
      });
      const _yield$customer$getCu = yield customer.getCustomerOrders({
          offset,
          limit
        }),
        {
          data = []
        } = _yield$customer$getCu,
        paging = (0, _objectWithoutProperties2.default)(_yield$customer$getCu, _excluded);
      mergeState({
        orderIds: (0, _uniq.default)([...state.orderIds, ...data.map(order => order.orderNo)]),
        ordersById: _objectSpread(_objectSpread({}, state.ordersById), data === null || data === void 0 ? void 0 : data.reduce((acc, order) => {
          return _objectSpread(_objectSpread({}, acc), {}, {
            [order.orderNo]: order
          });
        }, {})),
        paging,
        isLoading: false
      });
    });
    return function fetchOrders(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  const fetchOrder = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(function* (orderNo) {
      mergeState({
        isLoading: true
      });
      const order = yield customer.getOrder(orderNo);
      mergeState({
        ordersById: _objectSpread(_objectSpread({}, state.ordersById), {}, {
          [order.orderNo]: order
        }),
        isLoading: false
      });
    });
    return function fetchOrder(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  // We use this to track mounted state.
  (0, _react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const ctx = _react.default.useMemo(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      fetchOrders,
      fetchOrder
    });
  }, [state, customer, mergeState]);
  return /*#__PURE__*/_react.default.createElement(AccountOrdersContext.Provider, {
    value: ctx
  }, children);
};
exports.AccountOrdersProvider = AccountOrdersProvider;
AccountOrdersProvider.propTypes = {
  children: _propTypes.default.any
};

/**
 * A hook for managing account order history state
 * @returns {Object} Data and actions
 */
const useAccountOrders = () => {
  return _react.default.useContext(AccountOrdersContext);
};
exports.useAccountOrders = useAccountOrders;